var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:("height:100%;"),attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{on:{"setsickNess":_vm.reload}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }